export default function checkboxField(fieldName, store) {
    return {
        init() {
            const input = this.$el.querySelector('input[type="checkbox"]');
            if (!input) return;
            // init valeur depuis le DOM (SSR Symfony)
            //console.log('init checkbox field', fieldName, input.checked);
            if (!store) {
                throw new Error('Store is required for proper use of this component');
            }
            store?.initField?.(fieldName, input.checked);
        },

        onBlur() {
            store?.touch?.(fieldName);
        },

        get errorMessages() {
            return store?.getErrorMessages?.(fieldName) ?? [];
        },

        get hasError() {
            return store?.hasError?.(fieldName) ?? false;
        },

        get errorClass() {
            return (store?.hasError?.(fieldName) ?? false) ? 'has-error' : '';
        },
    };
}
